<template>
  <base-modal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :is-editable="false"
    :is-archivable="false"
    :no-close-on-backdrop="true"
    size="xl"
  >
    <template #header>
      {{ $t('routes.FirmCreate') }}
    </template>
    <template #body>
      <create :openedInModal="true"></create>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Create from '@/components/Dashboard/Views/firm/Create'

export default {
  name: 'CreateModal',
  components: {
    BaseModal,
    Create
  },

  props: ['clientType'],

  computed: {
    ...mapGetters({
      isVisible: 'userdata/createModal/isVisible',
      created: 'userdata/create/created'
    })
  },

  watch: {
    created (val) {
      if (val) this.hideModal()
    }
  },

  methods: {
    hideModal () {
      // this.reset()
      this.toggleModal()
    },
    ...mapActions({
      reset: 'userdata/create/reset'
    }),
    ...mapMutations({
      toggleModal: 'userdata/createModal/toggleModal'
    })
  }
}
</script>

<style scoped>

</style>
